module.exports = __webpack_public_path__ + "prod/1.42.2/img/hlw.4761a4a9.png";